
  <div class="row card-deck margin-top-0px">
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form">

      <div class="card-header wh-header border-bottom">
        Edit Package
        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
        <div class="modal-body overflow-x">

          <section id="form-action-layouts">


            <div class="row justify-content-md-center">
              <div class="col-md-12 padding-left-0px">
                <div class="card">

                  <div class="card-body">
                    <div class="px-6">



                      <div class="form-body">
                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">
                            <div class="row">
                              <div class="col-md-4 text-align-right padding-left-0px margin-top-auto margin-bottom-auto">
                                <label for="firstName" class="margin-bottom-0px"> Name of Package </label>
                              </div>
                              <div class="col-md-5 padding-left-0px">

                                <input type="text" class="form-control padding-left-0px">

                              </div>

                            </div>

                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">
                            <div class="row">
                              <div class="col-md-4 text-align-right padding-left-0px margin-top-auto margin-bottom-auto">
                                <label for="firstName" class="margin-bottom-0px">Service Category </label>
                              </div>
                              <div class="col-md-5 padding-left-0px">

                                <CodeTypeValue CodeType="MARTL"></CodeTypeValue>

                              </div>

                            </div>

                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">
                            <div class="row">
                              <div class="col-md-4 text-align-right padding-left-0px margin-top-auto margin-bottom-auto">
                                <label for="firstName" class="margin-bottom-0px">Revenue Category </label>
                              </div>
                              <div class="col-md-5 padding-left-0px">

                                <CodeTypeValue CodeType="MARTL"></CodeTypeValue>

                              </div>

                            </div>

                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">
                            <div class="row">
                              <div class="col-md-4 text-align-right padding-left-0px margin-top-auto margin-bottom-auto">
                                <label for="firstName" class="margin-bottom-0px">Profile </label>
                              </div>
                              <div class="col-md-5 padding-left-0px">

                                <CodeTypeValue CodeType="MARTL"></CodeTypeValue>

                              </div>

                            </div>

                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">
                            <div class="row">
                              <div class="col-md-4 text-align-right padding-left-0px margin-top-auto margin-bottom-auto">
                                <label for="firstName" class="margin-bottom-0px">Applicable To </label>
                              </div>
                              <div class="col-md-5 padding-left-0px">

                                <CodeTypeValue CodeType="MARTL"></CodeTypeValue>

                              </div>

                            </div>

                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">
                            <div class="row">
                              <div class="col-md-4 text-align-right padding-left-0px margin-top-auto margin-bottom-auto">
                                <label for="firstName" class="margin-bottom-0px">Package Status </label>
                              </div>
                              <div class="col-md-5 padding-left-0px">

                                <CodeTypeValue CodeType="MARTL"></CodeTypeValue>

                              </div>

                            </div>

                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">
                            <div class="row">
                              <div class="col-md-4 text-align-right padding-left-0px margin-top-auto margin-bottom-auto">
                                <label for="firstName" class="margin-bottom-0px">Valid Till </label>
                              </div>
                              <div class="col-md-5 padding-left-0px">

                                <div class="date-form">
                                  <input class="form-control form-control-patient" placeholder="Valid Till" [minDate]="minDate" [maxDate]="maxDate"
                                         name="dp" [(ngModel)]="DateOfBirth" ngbDatepicker #d="ngbDatepicker" #DOB="ngModel">
                                  <small class="form-text text-danger"
                                         *ngIf="(!DOB.valid && (DOB.dirty || DOB.touched) && DOB.errors.required)">(Field cannot be left blank)</small>

                                  <a (click)="d.toggle()" class="nav-link-hand">
                                    <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                  </a>
                                  
                                </div>
                              </div>

                            </div>

                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">
                            <div class="row">
                              <div class="col-md-4 text-align-right padding-left-0px margin-top-auto margin-bottom-auto">
                                <label for="firstName" class="margin-bottom-0px">Print Mode </label>
                              </div>
                              <div class="col-md-5 padding-left-0px">

                                <CodeTypeValue CodeType="MARTL"></CodeTypeValue>

                              </div>

                            </div>

                          </div>
                        </div>

                      </div>




               





                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          
        </div>


        <div class="modal-footer">
          <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
          <button type="submit"  class="btn actions-btn-prime float-right font-size-13px">Save</button>

        </div>

      </form>
    </div>
    </div>
 
